export enum Journey {
  ADOPTION = "ADOPTION",
  GESTATIONAL = "GESTATIONAL",
  PRESERVATION = "PRESERVATION",
  ASSISTED_REPRODUCTION = "ASSISTED_REPRODUCTION",
  TRY_PREGNANT = "TRY_PREGNANT",
  EXPLORING = "EXPLORING",
  PREGNANT = "PREGNANT",
  PARENTING = "PARENTING",
  MENOPAUSE = "MENOPAUSE",
  LOW_TESTOSTERONE = "LOW_TESTOSTERONE",
  GENDER_AFFIRMING_CARE = "GENDER_AFFIRMING_CARE",
  SOMETHING_ELSE = "SOMETHING_ELSE"
}
